import { Button, Link } from "@fluentui/react-components";
import React, { forwardRef } from "react";

import { M365PulseLinkProps } from "./M365PulseLink.types";
import { observer } from "mobx-react";
import { useLink } from "./useLink";

const M365PulseLinkBase = forwardRef<HTMLAnchorElement, M365PulseLinkProps>(
    (
        {
            children,
            path,
            onClick: onActivate,
            className,
            appearance,
            disabledFocusable,
            disabled,
            inline,
            openInNewTab,
            goToOSPV1,
            as,
            icon,
            iconPosition,
            ariaLabel
        },
        ref
    ) => {
        const { href, onClick, onKeyDown } = useLink(path ?? "", goToOSPV1, openInNewTab, onActivate);
        const linkAppearance = appearance === "secondary" ? "subtle" : appearance;

        if (!children && icon === undefined) {
            return null;
        }

        if (as === "button") {
            const buttonAppearance = appearance === "default" ? "primary" : appearance;
            return (
                <Button
                    className={className}
                    as="a"
                    onClick={onClick}
                    onKeyDown={onActivate ? onKeyDown : undefined}
                    appearance={buttonAppearance}
                    disabled={disabled}
                    href={href}
                    icon={icon}
                    iconPosition={iconPosition}
                    ref={ref}
                    aria-label={ariaLabel}
                >
                    {children}
                </Button>
            );
        }

        return (
            <Link
                href={href}
                onClick={onClick}
                appearance={linkAppearance}
                inline={inline}
                disabledFocusable={disabledFocusable}
                disabled={disabled}
                className={className}
                onKeyDown={onKeyDown}
                aria-label={ariaLabel}
                ref={ref}
                as={as}
            >
                {children}
            </Link>
        );
    }
);

export const M365PulseLink = observer(M365PulseLinkBase);
M365PulseLink.displayName = "M365PulseLink";
